import { AJAX_TIMEOUT_MESSAGE } from '../helpers.js';
import { handleSpaContentAuthError } from '../shared/spa-auth.js';
import { memberPages } from './member-nav-config.js';
import { showAlertMsg } from './member-show-alert-msg.js';

export function handleMemberSpaAuthError(xhr) {
    return handleSpaContentAuthError(xhr, {
        loginUrl: memberPages().signIn,
        alert: showAlertMsg,
    });
}

export function handleMemberSpaRequestError(xhr) {
    if (handleMemberSpaAuthError(xhr)) {
        return;
    }
    showAlertMsg(AJAX_TIMEOUT_MESSAGE, 'danger');
}
